import React, { createContext, useState, useMemo } from 'react'

import { PINFLAG_PRIMARY_COLOR } from '../constants/urls'

export const DataContext = createContext<any>(undefined)

export const DataProvider = ({ children }: { children: React.ReactNode }) => {
  const [companyData, setCompanyData] = useState<CompanyData | null>(null)

  const [loadingCompanyData, setLoadingCompanyData] = useState(false)

  const [companyDataLoaded, setCompanyDataLoaded] = useState(false)

  const [sale, setSale] = useState<Sale | null>(null)

  const [trackingNumber, setTrackingNumber] = useState<string | null>(null)

  const [totalProducts, setTotalProducts] = useState<TotalProduct | null>(null)

  const [loggedIn, setLoggedIn] = useState(false)

  const [companyColor, setCompanyColor] = useState<string>(PINFLAG_PRIMARY_COLOR)

  const [openAuthStep, setOpenAuthStep] = useState(0)

  const [openPopUp, setOpenPopUp] = useState(false)

  const [showCollections, setShowCollections] = useState(false)

  const [collections, setCollections] = useState<Collection[] | null>(null)

  const [showQrCode, setShowQrCode] = useState(false)

  const [qrCodeUrl, setQrCodeUrl] = useState<string | null>(null)

  const [courierEvents, setCourierEvents] = useState<CourierEvent[] | null>(null)

  const popUpState = useMemo(
    () => ({ openPopUp, setOpenPopUp }),
    [openPopUp]
  )

  return (
    <DataContext.Provider
      value={{
        companyData,
        setCompanyData,
        loggedIn,
        setLoggedIn,
        companyColor,
        setCompanyColor,
        sale,
        setSale,
        trackingNumber,
        setTrackingNumber,
        totalProducts,
        setTotalProducts,
        openAuthStep,
        setOpenAuthStep,
        openPopUp,
        setOpenPopUp,
        popUpState,
        showCollections,
        setShowCollections,
        showQrCode,
        setShowQrCode,
        qrCodeUrl,
        setQrCodeUrl,
        courierEvents,
        setCourierEvents,
        collections,
        setCollections,
        companyDataLoaded,
        setCompanyDataLoaded,
        loadingCompanyData,
        setLoadingCompanyData
      }}
    >
      {children}
    </DataContext.Provider>
  )
}
